import { useState, useEffect } from "react";
import { Input } from "antd";
import SearchIcon from "assets/icons/SearchIcon";
import styles from "./style.module.scss";

export interface VLSearchFilterProps<T> {
  items: T[];
  filterKey: keyof T;
  placeholder?: string;
  onFilter: (filtered: T[]) => void;
}

export default function VLSearchFilter({
  items,
  filterKey,
  placeholder = "Search",
  onFilter,
}: VLSearchFilterProps<any>) {
  const [query, setQuery] = useState("");

  useEffect(() => {
    const filtered = query.trim()
      ? items.filter((item) =>
          String(item[filterKey]).toLowerCase().includes(query.toLowerCase()),
        )
      : items;
    onFilter(filtered);
  }, [items, query, filterKey, onFilter]);

  return (
    <Input
      prefix={<SearchIcon />}
      placeholder={placeholder}
      allowClear
      value={query}
      onChange={(e) => setQuery(e.target.value)}
      rootClassName={styles.search}
    />
  );
}
